/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate(['WIDGETS_LOADED']);
